import { render } from "./submit-review-modal.vue?vue&type=template&id=90b6040a&ts=true"
import script from "./submit-review-modal.ts?vue&type=script&lang=ts&external"
export * from "./submit-review-modal.ts?vue&type=script&lang=ts&external"

import "./submit-review-modal.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__